// Triggers a Cylindo viewer's hidden ::part(fab) buttons from our own controls
const clickViewerControl = (viewerId, part) => {
  const viewer = document.getElementById(viewerId);
  viewer?.shadowRoot?.querySelector(`button[part~="${part}"]`)?.click();
};

export default clickViewerControl;
